import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import moment from 'moment';
import moment_es from 'moment/locale/es';

import './index.css';


moment.locale('es', moment_es);

function convertToMoney(string = false, decimales = true) {
  try {
    if (this) {
      // Eliminamos cualquier coma que haya en el número y nos aseguramos de que solo tenga 2 decimales
      var r = this.toString().replace(',', '').match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // Si el parámetro string es verdadero, devolvemos una cadena con separador de miles, Si no, devolvemos un número
      if(string === true){
        let formated = parseFloat(r).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        // Agregamos el decimal con dos decimales
        if(decimales)
          return formated + (formated.includes('.') ? '' : '.00');
        else
          return formated
      }else{
        return parseFloat(r)
      }
    }
    else
      return 0.00
  } catch (error) {
    return 0.00
  }
}

Number.prototype.toMoney = convertToMoney
String.prototype.toMoney = convertToMoney


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
FormData.prototype.appendMultiple = function (values) {
  for (const name in values) {
    if (values[name] !== null && values[name] !== undefined)
      if ("File" in window && values[name] instanceof File)
        this.append(name, values[name], values[name].name);
      else
        this.append(name, values[name]);
  }
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
